/**
 * FAQ Advanced - JavaScript moderne
 * Gère l'accordéon avec animations smooth
 */

const initFAQAdvanced = () => {
  const faqSections = document.querySelectorAll('.faq-advanced');
  
  faqSections.forEach(faqSection => {
    const items = faqSection.querySelectorAll('.faq-advanced_items .item');
    
    if (items.length === 0) return;

    items.forEach(item => {
      // Initialiser l'état fermé
      item.removeAttribute('open');
      item.style.paddingBottom = '0px';
      
      // Gérer le clic
      item.addEventListener('click', (e) => {
        e.preventDefault();
        
        const isOpen = item.hasAttribute('open');
        const content = item.querySelector('.item__content');
        
        // Fermer tous les autres items
        items.forEach(otherItem => {
          if (otherItem !== item && otherItem.hasAttribute('open')) {
            otherItem.removeAttribute('open');
            otherItem.style.paddingBottom = '0px';
          }
        });
        
        // Toggle l'item cliqué
        if (isOpen) {
          // Fermer
          item.removeAttribute('open');
          item.style.paddingBottom = '0px';
        } else {
          // Ouvrir
          item.setAttribute('open', '');
          
          // Calculer la hauteur du contenu pour animation smooth
          const contentHeight = content.scrollHeight;
          item.style.paddingBottom = `${contentHeight}px`;
          
          // Scroll smooth vers l'item ouvert (optionnel)
          setTimeout(() => {
            const itemTop = item.getBoundingClientRect().top + window.pageYOffset;
            const offset = 100; // Offset from top
            
            if (itemTop < window.pageYOffset) {
              window.scrollTo({
                top: itemTop - offset,
                behavior: 'smooth'
              });
            }
          }, 100);
        }
      });
      
      // Accessibilité clavier
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
      
      // Rendre l'item focusable
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      item.setAttribute('aria-expanded', 'false');
      
      // Mettre à jour aria-expanded quand l'état change
      const observer = new MutationObserver(() => {
        const isOpen = item.hasAttribute('open');
        item.setAttribute('aria-expanded', isOpen.toString());
      });
      
      observer.observe(item, {
        attributes: true,
        attributeFilter: ['open']
      });
    });
  });
};

// Initialiser au chargement
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQAdvanced);
} else {
  initFAQAdvanced();
}

// Réinitialiser si la page change (pour les SPA Shopify)
document.addEventListener('shopify:section:load', initFAQAdvanced);